<template>
  <div class="qrcode-view" :class="[paddingTop ? 'qrcode-view-top' : '']" v-show="data.length || data.length === 1 && data[0]">
    <div class="swiper-container" v-if="data.length > 1">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in data" :key="item.id" >
          <a :href="'javascript:'">
            <img :src="item.image" :data-url="item.url" :data-id="item.id" />
          </a>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <a v-if="data.length === 1 && data[0]" :href="'javascript:'" @click="onItem(data[0])">
      <img :src="data[0].image" />
    </a>
  </div>
</template>

<script>
import { fetch } from '@/commons/fetch'
import Swiper from 'swiper'
export default {
  props: {
    paddingTop: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      data: []
    }
  },
  mounted () {
    this.render()
  },
  methods: {
    init () {
      let self = this
      new Swiper('.swiper-container', {
        loop: true,
        autoplay: {
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          click (e) {
            if (e.target.nodeName === 'IMG' && e.target.dataset) {
              self.onItem(e.target.dataset)
            }
          }
        }
      })
    },
    render () {
      this.getData()
    },
    getData (payload = {}) {
      return new Promise((resolve, reject) => {
        fetch({
          url: 'https://jad-api.ushknews.com/mult/list_unread',
          params: payload.params || {
            display: 'mgdx_index',
            fit_type: 'wide_image',
            page: 'main'
          },
          type: 'get',
          useJson: true,
          headers: {
            'x-version': '1.0.0',
            'x-app-id': '4PPkjw2SEyAhkTDB'
          },
          callback: (res) => {
          },
          success: (res) => {
            const datas = res.data
            if (!datas.length) {
              return false
            }
            this.data = datas
            this.$nextTick(() => {
              this.init()
            })

            resolve(this.data)
          },
          error: () => {
          }
        })
      })
    },
    onItem (item) {
      window.open(item.url)
      return new Promise((resolve, reject) => {
        fetch({
          url: 'https://jad-api.ushknews.com/ad/ad_click_stat3',
          data: {
            ad_id: item.id
          },
          type: 'post',
          // useJson: true,
          headers: {
            'x-version': '1.0.0',
            'x-app-id': '4PPkjw2SEyAhkTDB'
          },
          callback: (res) => {
          },
          success: (res) => {
            console.log(res)
          },
          error: () => {
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.qrcode-view {
  //padding-bottom: 20px;
  border-bottom: 1px solid #f0f3f5;
  margin-bottom: 20px;
  margin-top: 2px;
  a{
    height: 158px;
    display: block;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  img {
    border-radius: 2px;
  }
}

.qrcode-view-top {
  img {
    //border-radius:0px;
  }
  /deep/.swiper-pagination{
    display: flex;
    align-items: center;
    width: auto;
    height: 14px;
    line-height: 14px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 10px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 7px;
    &-bullet{
      width: 6px;
      height: 6px;
      background: #FFFFFF;
      opacity: 1;
      &-active{
        width: 8px;
        height: 8px;
        background: #97ECFF;
        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.44);
        opacity: 0.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Ad.vue?c783cbce